"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateMigrationResult = exports.validateSingleMigrationResult = void 0;
const validation_1 = require("@fmtk/validation");
exports.validateSingleMigrationResult = (0, validation_1.properties)({
    email: (0, validation_1.text)(),
    success: (0, validation_1.bool)(),
    reason: (0, validation_1.optional)((0, validation_1.text)()),
});
exports.validateMigrationResult = (0, validation_1.properties)({
    users: (0, validation_1.array)(exports.validateSingleMigrationResult),
});
//# sourceMappingURL=MigrationResult.js.map